import * as defaultImport from "@splunk/react-search/utils/searchBNFs";
export * from "@splunk/react-search/utils/searchBNFs";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
